// extracted by mini-css-extract-plugin
module.exports = {"root":"container-module--root--1Rzp1","normal":"container-module--normal--1RoHj","large":"container-module--large--2dYOv","full":"container-module--full--3-OqP"};